import { TFunction } from 'react-i18next';

import { PackagingStep, ProductsStep, ShippingDetailsStep } from './components';

import type Step from './models/Step';

const getSteps = (t: TFunction): Step[] => [
    {
        title: t('STEPS.PRODUCTS.TITLE'),
        description: t('STEPS.PRODUCTS.DESCRIPTION'),
        Component: ProductsStep,
        fields: ['products', 'reason'],
        nextButtonLabel: t('STEPS.PRODUCTS.NEXT_LABEL'),
    },
    {
        title: t('STEPS.SHIPPING_DETAILS.TITLE'),
        description: t('STEPS.SHIPPING_DETAILS.DESCRIPTION'),
        Component: ShippingDetailsStep,
        fields: ['courier_service', 'transit', 'pickup_point'],
        nextButtonLabel: t('STEPS.SHIPPING_DETAILS.NEXT_LABEL'),
    },
    {
        title: t('STEPS.PACKAGE_PARAMETERS.TITLE'),
        description: t('STEPS.PACKAGE_PARAMETERS.DESCRIPTION'),
        Component: PackagingStep,
        fields: ['package_parameters'],
        nextButtonLabel: t('STEPS.PACKAGE_PARAMETERS.NEXT_LABEL'),
    },
];

export default getSteps;
